/* tslint:disable */
/* eslint-disable */
export enum BusinessType {
  Sales = 'SALES',
  Finance = 'FINANCE',
  Medvac = 'MEDVAC',
  Escort = 'ESCORT',
  Mcc = 'MCC',
  Academy = 'ACADEMY',
  Gh = 'GH',
  Acm = 'ACM',
  Flight = 'FLIGHT',
  Training = 'TRAINING',
  SalesOrder = 'SALES_ORDER',
  SalesWorkOrder = 'SALES_WORK_ORDER',
  AirportManagementService = 'AIRPORT_MANAGEMENT_SERVICE',
  AcmsSales = 'ACMS_SALES',
  AcmsSalesWorkOrder = 'ACMS_SALES_WORK_ORDER',
}
